import React from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../../components/layout/Layout';
import TeamAssistantPageWorkspace from '../../components/assistant/TeamAssistantPageWorkspace';
import './index.css';
import './team-assistant-chatgpt-theme.css';

const TeamAssistantPage = () => {
  const { currentUser } = useSelector((state) => state.user);

  return (
    <PageLayout>
      <div className="team-assistant-page team-assistant-page-single">
        <TeamAssistantPageWorkspace currentUser={currentUser} />
      </div>
    </PageLayout>
  );
};

export default TeamAssistantPage;
